import type { CSSProperties } from 'react';
import { formatCourseHumanId } from '../../utils/humanIds';
import type { CourseDraft } from './types';

function formatAccounts(count: number): string {
  return `${count} ${count === 1 ? 'account' : 'accounts'}`;
}

interface InternalDetailsSectionProps {
  draft: CourseDraft;
  styles: Record<string, CSSProperties>;
}

export function InternalDetailsSection({ draft, styles }: InternalDetailsSectionProps) {
  return (
    <section style={styles.card}>
      <div style={styles.cardHeader}>
        <h2 style={styles.cardTitle}>Internal details</h2>
      </div>
      <div style={styles.cardBody}>
        <div style={styles.detailGrid}>
          <div>
            <div style={styles.detailLabel}>Course ID</div>
            <div style={{ ...styles.detailValue, ...styles.monospace }}>
              {formatCourseHumanId(draft.numericId, draft.id)}
            </div>
          </div>
          <div>
            <div style={styles.detailLabel}>Assigned Accounts</div>
            <div style={styles.detailValue}>{formatAccounts(draft.assignedAccountIds.length)}</div>
          </div>
          <div>
            <div style={styles.detailLabel}>Customized By</div>
            <div style={styles.detailValue}>{formatAccounts(draft.customizedByAccountCount)}</div>
          </div>
          <div>
            <div style={styles.detailLabel}>Additional fields</div>
            <div style={styles.detailValue}>Coming soon</div>
          </div>
        </div>
      </div>
    </section>
  );
}
